import React from 'react';
import exact from 'prop-types-exact';
import {
  Row,
  Col,
} from 'react-bootstrap';
import PasswordResetRequestForm from './PasswordResetRequestForm';

import logo from '../../../../images/HSI_logo_no_subtext.png';

const propTypes = exact({
});


const LayoutWithEmbeddedForm = (props) => {
  return (
    <div className="panel-body">
      <div className="panel panel-default">
        <div className="panel-body">
          <Row>
            <Col md={4}>
              <img src={logo} alt="logo" />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <h3>Hurricane Service Inc.</h3>
            </Col>
          </Row>
          <PasswordResetRequestForm />
        </div>
      </div>
    </div>
  );
};


LayoutWithEmbeddedForm.propTypes = propTypes;

export default LayoutWithEmbeddedForm;
